export default "__VITE_ASSET__DXDn2DNo__"